import apiClient from '@/shared/lib/apiClient';
import type { Collect } from '../types';

export async function downloadCollectPDF(agreementUuid: string, collect: Collect): Promise<void> {
  const res = await apiClient.post<Blob>(
    `/agreements/${agreementUuid}/nsr/${collect.nsr}/generate/ticket`,
    {},
    { responseType: 'blob' },
  );
  const blob = new Blob([res.data], { type: 'application/pdf' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `comprovante-${collect.date}-${collect.time.substring(0, 5).replace(':', '')}.pdf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}
